export { getPredictedRevenueFromMortgage } from './getPredictedRevenueFromMortgage'
